import { Box } from '@mui/material'
import { useMemo } from 'react'
import { CapacityTableProps } from './Capacity.types'
import { BaseTable } from 'Features/Table/BaseTable.view'
import { ExtendedGridColDef } from 'Features/Table/BulkUpdateModal'

export const CapacityMUITable = ({ data, isLoading }: CapacityTableProps) => {
  const columns: ExtendedGridColDef[] = useMemo(
    () => [
      {
        headerName: 'Sequence',
        field: 'productionSequence',
        flex: 1,
        type: 'number',
      },
      {
        headerName: 'SKU code',
        field: 'skuCode',
        flex: 1,
        type: 'string',
      },
      {
        headerName: 'SKU name',
        field: 'skuName',
        flex: 1,
        type: 'string',
      },
      {
        headerName: 'Cycle',
        field: 'productionCycleTime',
        flex: 1,
        type: 'number',
      },
      {
        headerName: 'MOQ / MOI',
        field: 'minimumProductionOrderQuantity',
        flex: 1,
        type: 'number',
        valueFormatter: (params, dta) => {
          if (params) {
            return `${params} / ${dta?.minimumProductionOrderIncrement}`
          }
          return ''
        },
      },
      {
        headerName: 'Run rate',
        field: 'runRate',
        flex: 1,
        type: 'number',
      },
      {
        headerName: 'Planned volume',
        field: 'productionAmount',
        flex: 1,
        type: 'number',
      },
      {
        headerName: 'Production time',
        field: 'productionTimeHours',
        flex: 1,
        type: 'number',
      },
      {
        headerName: 'Changeover time',
        field: 'changeOverTimeHours',
        flex: 1,
        type: 'number',
      },
    ],
    [data]
  )

  // No-op functions for BaseTable required props (read-only table)
  const updateTableData = () => {
    // This is a read-only table, no updates needed
  }

  const uploadData = () => {
    // No upload functionality needed
  }

  return (
    <Box
      sx={{
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
        height: '100%',
        minHeight: 0,
      }}
    >
      <BaseTable
        data={data ?? []}
        columns={columns}
        isLoading={isLoading}
        updateTableData={updateTableData}
        uploadData={uploadData}
        isUploading={false}
        isSaving={false}
        checkBoxSelection={false}
        showTableToolBar={true}
        downloadFileName="CapacityData"
        getRowId={(row) => row.id}
      />
    </Box>
  )
}
